import { Component } from "@angular/core";
import { UserDetailsFormComponent } from "./user-details-form/user-details-form.component";
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: "app-user-details",
    standalone: true,
    imports: [UserDetailsFormComponent, MatIconModule],
    templateUrl: "./user-details.component.html",
    styleUrls: ["./user-details.component.scss"],
})
export class UserDetailsComponent {
    public logoUrl = "../../assets/images/funfigz-logo.png";
}
